import { createContext } from "react";
export const CodeSpaceContext = createContext();